/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/get-iterator.js
 ** module id = 43
 ** module chunks = 0
 **/